import React, { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { getCartableCount } from "api/cartableservice";
import { Badge } from "antd";

const CartableCount = forwardRef((props, ref) => {

  const [count, setCount] = useState(0);

  const fetchData = () => {
    getCartableCount()
      .then((res) => setCount(res.data.cartableCount))
      .catch((err) => console.error(err));
  };
  useEffect(() => {
 
  fetchData(); // بار اول
  const intervalId = setInterval(fetchData, 2 * 60 * 1000); // هر ۲ دقیقه

  return () => clearInterval(intervalId); 
  }, []);

  //make fetchdata accessable from outside this component
  useImperativeHandle(ref, () => ({
      refresh: () => {
      fetchData();
      },
  }));

  return (
    <Badge count={count} size="normall" />
   
  );
});

export default CartableCount;
